var map = {
	"./campus-platform-moduleA-icon1.png": 507,
	"./campus-platform-moduleA-icon10.png": 508,
	"./campus-platform-moduleA-icon11.png": 509,
	"./campus-platform-moduleA-icon12.png": 510,
	"./campus-platform-moduleA-icon13.png": 511,
	"./campus-platform-moduleA-icon14.png": 512,
	"./campus-platform-moduleA-icon15.png": 513,
	"./campus-platform-moduleA-icon16.png": 514,
	"./campus-platform-moduleA-icon2.png": 515,
	"./campus-platform-moduleA-icon3.png": 516,
	"./campus-platform-moduleA-icon4.png": 517,
	"./campus-platform-moduleA-icon5.png": 518,
	"./campus-platform-moduleA-icon6.png": 519,
	"./campus-platform-moduleA-icon7.png": 520,
	"./campus-platform-moduleA-icon8.png": 521,
	"./campus-platform-moduleA-icon9.png": 522,
	"./campus-platform-moduleA-img1.png": 523,
	"./campus-platform-moduleA-img2.png": 524,
	"./campus-platform-moduleB-icon1.png": 525,
	"./campus-platform-moduleB-icon10.png": 526,
	"./campus-platform-moduleB-icon11.png": 527,
	"./campus-platform-moduleB-icon12.png": 528,
	"./campus-platform-moduleB-icon13.png": 529,
	"./campus-platform-moduleB-icon14.png": 530,
	"./campus-platform-moduleB-icon15.png": 531,
	"./campus-platform-moduleB-icon16.png": 532,
	"./campus-platform-moduleB-icon17.png": 533,
	"./campus-platform-moduleB-icon18.png": 534,
	"./campus-platform-moduleB-icon19.png": 535,
	"./campus-platform-moduleB-icon2.png": 536,
	"./campus-platform-moduleB-icon20.png": 537,
	"./campus-platform-moduleB-icon21.png": 538,
	"./campus-platform-moduleB-icon22.png": 539,
	"./campus-platform-moduleB-icon23.png": 540,
	"./campus-platform-moduleB-icon24.png": 541,
	"./campus-platform-moduleB-icon25.png": 542,
	"./campus-platform-moduleB-icon26.png": 543,
	"./campus-platform-moduleB-icon27.png": 544,
	"./campus-platform-moduleB-icon28.png": 545,
	"./campus-platform-moduleB-icon29.png": 546,
	"./campus-platform-moduleB-icon3.png": 547,
	"./campus-platform-moduleB-icon30.png": 548,
	"./campus-platform-moduleB-icon31.png": 549,
	"./campus-platform-moduleB-icon32.png": 550,
	"./campus-platform-moduleB-icon33.png": 551,
	"./campus-platform-moduleB-icon4.png": 552,
	"./campus-platform-moduleB-icon5.png": 553,
	"./campus-platform-moduleB-icon6.png": 554,
	"./campus-platform-moduleB-icon7.png": 555,
	"./campus-platform-moduleB-icon8.png": 556,
	"./campus-platform-moduleB-icon9.png": 557,
	"./campus-platform-moduleB-img1.png": 558,
	"./campus-platform-moduleB-img2.png": 559,
	"./campus-platform-moduleB-img3.png": 560,
	"./campus-platform-moduleB-img4.png": 561,
	"./campus-platform-moduleB-img5.png": 138,
	"./campus-platform-moduleC-bg.png": 139,
	"./campus-platform-moduleD-icon1.png": 140,
	"./campus-platform-moduleD-icon2.png": 141,
	"./campus-platform-moduleE-icon1.png": 142,
	"./campus-platform-moduleE-icon10.png": 143,
	"./campus-platform-moduleE-icon2.png": 144,
	"./campus-platform-moduleE-icon3.png": 145,
	"./campus-platform-moduleE-icon4.png": 146,
	"./campus-platform-moduleE-icon5.png": 147,
	"./campus-platform-moduleE-icon6.png": 148,
	"./campus-platform-moduleE-icon7.png": 149,
	"./campus-platform-moduleE-icon8.png": 150,
	"./campus-platform-moduleE-icon9.png": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;